<template>
  <!-- 验证科目是否正确 -->
  <div class="test-sub-box" v-show="subBoxShow">
    <div class="sub-mask"></div>
    <div class="sub-content">
      <i class="iconfont icon-close icon" @click="handleCloseSub"></i>
      <div class="current-sub">
        <span class="title">课程科目为</span>
        <span class="content" v-if="text && subjectName">{{ text }}-{{ subjectName }}</span>
        <span class="content" v-else>无课程科目</span>
      </div>

      <div class="your-sub">
        <div class="your-sub-top">
          <span class="title">您的个人信息为</span>
          <span class="content" v-if="One">{{ One.stageName }}-{{ One.subjectName }}</span>
        </div>
        <ul class="your-sub-list">
          <li v-for="item in Ohter" :key="item.stageId">{{ item.stageName }}-{{ item.subjectName }}</li>
        </ul>
      </div>

      <div class="tips">由于科目信息不符，申请学时请填写申请</div>

      <div class="come-study" @click="handleApplyForm">填写申请</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'test-sub-box',
  props: {
    subBoxShow: {
      type: Boolean
    },
    id: {
      type: String,
      required: true
    },
    text: {
      type: String
    },
    subjectName: {
      type: String
    },
    userSubjects: {
      type: Array
    },
    applyType: {
      type: Number
    }
  },
  data() {
    return {
      One: null,
      Ohter: []
    }
  },
  methods: {
    handleCloseSub() {
      this.$emit('CloseSub')
    },
    handleApplyForm() {
      this.handleCloseSub()
      this.$router.push(`/certificate/applyform/${this.id}?applyType=${this.applyType}`)
    }
  },
  watch: {
    userSubjects(newVal) {
      this.One = newVal[0]
      if (newVal.length > 1) {
        const arr = JSON.parse(JSON.stringify(newVal))
        arr.shift()
        this.Ohter = arr
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.test-sub-box {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  .sub-mask {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 5, 26, 0.4);
    z-index: 100;
  }
  .sub-content {
    position: absolute;
    left: 10%;
    top: 50%;
    margin-top: -50%;
    width: 80%;
    padding: 36px 30px;
    box-sizing: border-box;
    background-color: #ffffff;
    border-radius: 12px;
    z-index: 101;
    .icon {
      position: absolute;
      right: 12px;
      top: 12px;
    }
    .current-sub {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      .title {
        color: #909399;
        font-size: 14px;
      }
      .content {
        padding: 13px 16px;
        box-sizing: border-box;
        color: #303133;
        font-weight: 500;
        background-color: rgba(#e7e9ef, 0.32);
        border-radius: 20px;
      }
    }
    .your-sub {
      margin-top: 12px;
      .your-sub-top {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        .title {
          color: #909399;
          font-size: 14px;
        }
        .content {
          padding: 13px 16px;
          box-sizing: border-box;
          color: #303133;
          font-weight: 500;
          background-color: rgba(#e7e9ef, 0.32);
          border-radius: 20px;
        }
      }
      .your-sub-list {
        margin-top: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        li {
          margin-bottom: 10px;
          padding: 13px 16px;
          box-sizing: border-box;
          color: #303133;
          font-weight: 500;
          background-color: rgba(#e7e9ef, 0.32);
          border-radius: 20px;
        }
      }
    }
    .tips {
      text-align: center;
      margin-top: 10px;
      font-size: 13px;
      color: #909399;
    }
    .come-study {
      margin-top: 20px;
      width: 100%;
      height: 40px;
      background: linear-gradient(270deg, #4465f3, #4a86f6);
      border-radius: 20px;
      text-align: center;
      line-height: 40px;
      color: #fff;
      font-size: 14px;
      box-sizing: border-box;
    }
  }
}
</style>
